import { CSSProperties } from "react";
import { IText } from "src/ScrollyInterface";

export const getTextStyle = (p: IText): CSSProperties => {
  const style: CSSProperties = {};
  if(p) {
    if (p.align) {
      style.alignSelf = getAlignement(p.align);
    }
    style.fontFamily = p.font = !p.font ? undefined : p.font;
    style.fontSize = p.font_size = !p.font_size ? undefined : p.font_size;
    style.fontStyle = p.font_style = !p.font_style ? undefined : p.font_style;
    style.fontWeight = p.font_weight = !p.font_weight ? undefined : p.font_weight;
    style.color = p.color = !p.color ? undefined : p.color;
    style.letterSpacing = p.letter_spacing = !p.letter_spacing
      ? undefined
      : p.letter_spacing;
    style.lineHeight = p.line_height = !p.line_height ? undefined : p.line_height;
    style.marginTop = p.margin_top = !p.margin_top ? undefined : p.margin_top;
    // return style;
  }
  return style;
};

export const getAlignement = (side?: "left" | "center" | "right") => {
  switch (side) {
    case "left":
      return "flex-start";
    case "center":
      return "center";
    default:
      return "flex-end";
  }
};



// WEBPACK FOOTER //
// ./src/shared/getTextStyle.tsx